import { Tooltip } from '@montel/montelpro-shared-components-v2';
import { cloneElement, ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

type DisabledProp = 'isDisabled' | 'disabled';

interface ConditionallyDisabledProps<TDisabledProp extends DisabledProp> {
	disableIf: boolean;
	tooltip: ReactNode;
	disabledProp?: TDisabledProp;
	children: ReactElement<Record<TDisabledProp, boolean>>;
}

const StyledTooltip = styled(Tooltip)`
	margin-left: 0;
`;

export const ConditionallyDisabled = <
	TDisabledProp extends DisabledProp = 'isDisabled',
>({
	disableIf,
	tooltip,
	disabledProp,
	children,
}: ConditionallyDisabledProps<TDisabledProp>) => {
	if (!disableIf) return children;

	const disabledKey = (disabledProp ?? 'isDisabled') as string;

	return (
		<StyledTooltip
			component={cloneElement(children as ReactElement, {
				[disabledKey]: true,
			})}
			unbound
		>
			{tooltip}
		</StyledTooltip>
	);
};
